export default __webpack_public_path__ + "static/media/darc.d6cddf51.png";